import { Box, TableRow, Typography } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import MyTableCell from '../../../components/material-ui/adaptive/MyTableCell';
import CusCheckbox from '../../../components/material-ui/CusCheckbox';
import CusInput from '../../../components/material-ui/CusInput';
import CusSwitch from '../../../components/material-ui/CusSwitch';
import CusLabelSelect from '../../../components/material-ui/CusLabelSelect';
import { options0To100Percent } from '../../../enums/enums';
import useToast from '../../../hooks/useToast';
import TypographyText from '../../../components/material-ui/table/TypographyText';
import { useTranslation } from 'react-i18next';

function GambitProvidersListRow({
  providerName,
  provider,
  indx,
  selected,
  setSelected,
  onChangeStatus,
  onChangeCommission,
  setProvidersHas,
  changeProviderParam
}) {
  const { errorToast } = useToast();
  const { t } = useTranslation();

  const CusTableCell = ({ children, ...props }) => (
    <MyTableCell sx={{ py: 0 }} {...props}>
      {children}
    </MyTableCell>
  );

  const [customName, setCustomName] = useState(provider.customName);

  useEffect(() => {
    setCustomName(provider.customName);
  }, [provider.customName]);

  const onCustomNameChange = async () => {
    if (!customName) {
      errorToast('Provider name cannot be empty');
      setCustomName(provider.customName);
      return;
    }

    const res = await changeProviderParam({ provider: providerName, customName });
    if (res) {
      setProvidersHas((prev) => {
        return { ...prev, [providerName]: { ...provider, customName: customName } };
      });
    } else setCustomName(provider.customName);
  };

  return (
    <TableRow sx={{ '&:hover': { backgroundColor: 'action.hover' } }}>
      <CusTableCell>{indx + 1}</CusTableCell>
      <CusTableCell>
        <CusCheckbox
          isVerySmall
          checked={selected.includes(providerName)}
          onChange={() =>
            setSelected((prev) =>
              prev.includes(providerName)
                ? prev.filter((el) => el !== providerName)
                : [...prev, providerName]
            )
          }
        />
      </CusTableCell>

      <CusTableCell>
        <Typography>
          {providerName}{' '}
          <TypographyText color="textSecondary">({provider.gameCount})</TypographyText>
        </Typography>
      </CusTableCell>
      <CusTableCell>
        <Typography>{provider.currencies?.join(',') || t('All')} </Typography>
      </CusTableCell>
      <MyTableCell>
        <CusInput
          isVerySmall
          autoComplete={'off'}
          value={customName}
          onChange={(e) => setCustomName(e.target.value)}
          onBlur={onCustomNameChange}
        />
      </MyTableCell>
      <CusTableCell>
        <CusSwitch
          isVerySmall
          checked={provider.enabled}
          onChange={() => onChangeStatus(providerName)}
        />
      </CusTableCell>
      <CusTableCell>
        <CusLabelSelect
          isVerySmall
          options={options0To100Percent}
          value={'' + provider.percent}
          onChange={(newValue) => onChangeCommission(providerName, newValue)}
        />
      </CusTableCell>
    </TableRow>
  );
}

export default memo(GambitProvidersListRow);
